import { takeLatest } from 'redux-saga/effects';
import {
	getJobRoleRequestListSuccess, getJobRoleRequestListFail,
	getJobRoleRequestDetailsSuccess, getJobRoleRequestDetailsFail,
	getJobRoleBudgetSuccess, getJobRoleBudgetFail,
    getJobRoleDescriptionSuccess, getJobRoleDescriptionFail,
    getJobRoleSkillsSuccess, getJobRoleSkillsFail
} from './jobRoleRequestState';
import createCrudService from '../../services/crudservice';
import createAIAgentService from '../../services/aiagentservice';
import { 
	doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/recruitment/job-role-requests');
const redirectData = {route:'/console/job-role-requests', mode: 'list', recordId:0 };
const modelName = 'Job Role Request';
const modelId = 'jrr_id';

const aiAgentService = createAIAgentService();

function* getJobRoleRequestList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload), 
		getJobRoleRequestListSuccess, 
		getJobRoleRequestListFail, null, null, LOADING_MSG);
}

function* getJobRoleRequestDetails(data) {
	yield doCrudCall(
		() => crudService.getDetails(data.payload), 
		getJobRoleRequestDetailsSuccess, 
		getJobRoleRequestDetailsFail, 
		null, null, LOADING_MSG);		
}

function* doJobRoleRequestCreate(data){
	yield doCrudCall(
		() => crudService.doCreate(data.payload), 
		getJobRoleRequestDetailsSuccess, 
		getJobRoleRequestDetailsFail,
		createRecordSuccess(modelName),
		{...redirectData, mode: "reload" },
		SAVING_MSG);
}

function* doJobRoleRequestUpdate(data){
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload), 
		getJobRoleRequestDetailsSuccess, 
		getJobRoleRequestDetailsFail,
		updateRecordSuccess(modelName),
		{...redirectData, mode: "reload" },
		UPDATING_MSG);	
}

function* doJobRoleRequestDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getJobRoleRequestDetailsSuccess, 
		getJobRoleRequestDetailsFail,
		deleteRecordSuccess(modelName),
		{...redirectData, mode: data.payload.mode},
		DELETING_MSG);	
}

function* getJobRoleBudget(data){
	yield doCrudCall(
		() => aiAgentService.invokeAgent(data.payload, 'job-role/agent-suggestion'), 
		getJobRoleBudgetSuccess, 
		getJobRoleBudgetFail,
		null, null, null);	
}

function* getJobRoleDescription(data){
	yield doCrudCall(
		() => aiAgentService.invokeAgent(data.payload, 'job-role/agent-suggestion'), 
		getJobRoleDescriptionSuccess, 
		getJobRoleDescriptionFail,
		null, null, null);	
}

function* getJobRoleSkills(data){
	yield doCrudCall(
		() => aiAgentService.invokeAgent(data.payload, 'job-role/agent-suggestion'), 
		getJobRoleSkillsSuccess, 
		getJobRoleSkillsFail,
		null, null, null);	
}

function* doJobRoleRequestEditJobPost(data){
	const endpoint = `${data.payload}/create-job-post`;
	yield doCrudCall(
		() => crudService.doGetRequest(endpoint), 
		getJobRoleRequestDetailsSuccess, 
		getJobRoleRequestDetailsFail,
		null,null,LOADING_MSG);	
}

function* doJobRoleRequestSaveJobPost(data){
	const { recordId } = data.payload;
	const endpoint = `${recordId}/create-job-post`;
	yield doCrudCall(
		() => crudService.doPostRequest(endpoint, data.payload), 
		getJobRoleRequestDetailsSuccess, 
		getJobRoleRequestDetailsFail,
		'Job Post has been created for this job request.',
		{...redirectData, mode: "reload" },
		'Creating Job Post');	
}

function* jobRoleRequestSaga() {
	yield takeLatest('jobRoleRequest/getJobRoleRequestList', getJobRoleRequestList);
	yield takeLatest('jobRoleRequest/getJobRoleRequestDetails', getJobRoleRequestDetails);
	yield takeLatest('jobRoleRequest/doJobRoleRequestCreate', doJobRoleRequestCreate);
	yield takeLatest('jobRoleRequest/doJobRoleRequestUpdate', doJobRoleRequestUpdate);
	yield takeLatest('jobRoleRequest/doJobRoleRequestDelete', doJobRoleRequestDelete); 
	yield takeLatest('jobRoleRequest/getJobRoleBudget', getJobRoleBudget); 
	yield takeLatest('jobRoleRequest/getJobRoleDescription', getJobRoleDescription); 
	yield takeLatest('jobRoleRequest/getJobRoleSkills', getJobRoleSkills); 
	yield takeLatest('jobRoleRequest/doJobRoleRequestEditJobPost', doJobRoleRequestEditJobPost); 
	yield takeLatest('jobRoleRequest/doJobRoleRequestSaveJobPost', doJobRoleRequestSaveJobPost); 
	
}

export default jobRoleRequestSaga;
